module.exports = __webpack_public_path__ + "static/media/dots-border.f891af26.svg";